export default "__VITE_ASSET__CWm9RXEV__"